module.exports = __webpack_public_path__ + "static/media/Slide39.2da7089b.JPG";